import { render, staticRenderFns } from "./RecuperarDadosUsuario.vue?vue&type=template&id=1c47410a"
import script from "./RecuperarDadosUsuario.vue?vue&type=script&lang=ts"
export * from "./RecuperarDadosUsuario.vue?vue&type=script&lang=ts"
import style0 from "./RecuperarDadosUsuario.vue?vue&type=style&index=0&id=1c47410a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports